import { render, staticRenderFns } from "./iv-settle-account.vue?vue&type=template&id=20f90f0c"
import script from "./iv-settle-account.vue?vue&type=script&lang=ts"
export * from "./iv-settle-account.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports